// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__19IvE","name":"ConsentHeader_name__3wPFY","birthday":"ConsentHeader_birthday__s14p8","skeleton":"ConsentHeader_skeleton__1ynIZ"};